import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type MessageState = {
	errorMessage: string;
	setErrorMessage: (msg: string | undefined) => void;
	clearMessage: () => void;
};

export const useErrorMessageStore = create<MessageState>()(
	persist(
		(set) => ({
			errorMessage: '',
			setErrorMessage: (msg) => set({ errorMessage: msg ?? '' }),
			clearMessage: () => set({ errorMessage: '' }),
		}),
		{
			name: 'message-storage',
			storage: createJSONStorage(() => sessionStorage),
		},
	),
);
